var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.882 5.753a2.48 2.48 0 0 1 2.482 2.483v1.307l4.038-2.355.125-.063a1.07 1.07 0 0 1 .822-.003l.126.062.117.078a1.07 1.07 0 0 1 .42.85v7.716a1.071 1.071 0 0 1-1.663.89h-.001l-3.984-2.656v1.703a2.48 2.48 0 0 1-2.482 2.482H4.47a2.483 2.483 0 0 1-2.483-2.482v-7.53A2.483 2.483 0 0 1 4.47 5.754zm-9.412 1.2c-.708 0-1.283.575-1.283 1.283v7.529c0 .708.575 1.283 1.283 1.283h9.412c.708 0 1.282-.575 1.282-1.283v-7.53c0-.708-.574-1.282-1.282-1.282zm11.894 3.98v1.686l4.449 2.965V8.337z"
  })));
};
export default SvgVideo;